import { ClipboardList, FileText, FilePlus, X } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSelectDailyScrum: () => void;
  onSelectTemplate: () => void;
  onSelectBlankPage: () => void;
}

const OPTIONS = [
  {
    key: 'scrum',
    icon: ClipboardList,
    title: '데일리 스크럼',
    description: '팀원별 어제/오늘/블로커를 기록합니다',
    color: 'text-blue-600',
  },
  {
    key: 'template',
    icon: FileText,
    title: '템플릿에서 선택',
    description: '저장된 템플릿으로 회의록을 생성합니다',
    color: 'text-purple-600',
  },
  {
    key: 'blank',
    icon: FilePlus,
    title: '빈 페이지',
    description: '자유 형식의 빈 문서를 생성합니다',
    color: 'text-gray-600',
  },
] as const;

export default function MeetingTypeSelectModal({
  isOpen,
  onClose,
  onSelectDailyScrum,
  onSelectTemplate,
  onSelectBlankPage,
}: Props) {
  if (!isOpen) return null;

  const handlers: Record<string, () => void> = {
    scrum: onSelectDailyScrum,
    template: onSelectTemplate,
    blank: onSelectBlankPage,
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={onClose}>
      <div className="bg-white rounded-xl shadow-xl w-[400px] max-w-[95vw] p-5 space-y-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-900">회의 유형 선택</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="size-4" />
          </button>
        </div>

        <div className="space-y-2">
          {OPTIONS.map((opt) => (
            <button
              key={opt.key}
              onClick={() => { handlers[opt.key](); onClose(); }}
              className="w-full flex items-start gap-3 p-4 border border-gray-200 rounded-lg text-left hover:bg-gray-50 hover:border-blue-300 transition-colors"
            >
              <opt.icon className={`size-5 shrink-0 mt-0.5 ${opt.color}`} />
              <div>
                <p className="text-sm font-medium text-gray-900">{opt.title}</p>
                <p className="text-sm text-gray-500 mt-0.5">{opt.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
